import React, { Component } from 'react';
import { DatePicker, List, Flex, Modal, Toast } from 'antd-mobile';
import F2 from '@antv/f2';
import { ROOT_PATH } from '../../config';
import df from 'dateformat';
import SwineDetails from './npDetails';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';
import EmptyReport from '../../components/EmptyReport';

const today = new Date();
// let Shape = F2.Shape;
// let Util = F2.Util;
let dataReady = 0;
let clientWidth = document.documentElement.clientWidth;
class RealTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      dataNoData: false, // 饼图没有数据
      stockQty: [],
      percent: [],
      data1: [],
      tables: [],
      totalQty: '', // 总脱产母猪
      aveNPDay: '', // 平均脱产天数
      npPer: '' // 脱产母猪占比
    };
  }
  getReport01 = (data1) => {
    // const {data1} = this.state;
    let data = [];
    let sum = data1.reduce((t, o) => t + o.val, 0);
    this.setState({
      dataNoData: sum === 0
    });
    data1.forEach((item) => {
      data.push({
        amount: item.val,
        ratio: Math.round((item.val / sum) * 100) / 100,
        memo: item.descLoc,
        const: 'const'
      });
    });
    let chart = this.chart1;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'myChart1',
        padding: [120, 'auto', 35, 'auto'],
        plugins: require('@antv/f2/lib/plugin/pie-label'),
        pixelRatio: window.devicePixelRatio
      });
    }
    this.chart1 = chart;
    chart.source(data);
    chart.coord('polar', {
      transposed: true,
      innerRadius: 0.4,
      radius: 0.75
    });
    chart.axis(false);
    chart.legend({
      position: 'top',
      align: 'center',
      marker: {
        radius: 6
      },
      titleStyle: {
        fontSize: 14
      }
    });
    chart.tooltip(false);
    chart.guide().html({
      position: ['50%', '50%'],
      html: '<div style="width: 100px;height: 20px;text-align: center;line-height: 20px;" id="textContent"></div>'
    });
    // 配置文本饼图
    chart.pieLabel({
      sidePadding: 20,
      lineHeight: 45,
      label1OffsetY: -5,
      label2OffsetY: 5,
      label1: function label2(data) {
        const text = data.memo.split('>')[0];
        return {
          fill: '#999',
          text: text,
          fontWeight: 500,
          fontSize: 10
        };
      },
      label2: function label2(data) {
        return {
          fill: '#000000',
          text: data.amount + '头 (' + data.ratio + '%)',
          fontWeight: 500,
          fontSize: 10
        };
      }
    });
    chart
      .interval()
      .position('const*ratio')
      .color('memo', ['#1890FF', '#31C0B0', '#F2E129', '#897DEC', '#F5427E'])
      .adjust('stack');
    chart.render();

    // 绘制内阴影
    var frontPlot = chart.get('frontPlot');
    var coord = chart.get('coord'); // 获取坐标系对象
    frontPlot.addShape('sector', {
      attrs: {
        x: coord.center.x,
        y: coord.center.y,
        r: coord.circleRadius * coord.innerRadius * 1.2, // 全半径
        r0: coord.circleRadius * coord.innerRadius,
        fill: '#000',
        opacity: 0.15
      }
    });
    chart.get('canvas').draw();
  };
  // 表格
  getData2 = (date) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/nonProductStateTable01/1`,
        qs.stringify({
          startDate: date,
          endDate: date,
          dateToday: date,
          gd_type: 'D000501',
          gd_code: '10'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        dataReady++;
        this.setState({ tables: res.data });
      })
      .catch((err) => {
        return err;
      });
  };
  getData1 = (date) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/nonProductStateGraph/0`,
        qs.stringify({
          startDate: date,
          endDate: date,
          dateToday: date,
          gd_type: 'D000501',
          gd_code: '2001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        dataReady++;
        let data1 = res.data.filter((item) => item.descLoc !== '当前状态分娩>23天');
        this.setState({
          data1
        });
        this.getReport01(data1);
      })
      .catch((err) => {
        return err;
      });
  };
  getTotal = (date) => {
    axios
      .post(
        `${ROOT_PATH}/api/forward/ifarm/nonProductDaystTotal`,
        qs.stringify({
          startDate: date,
          endDate: date,
          dateToday: date,
          gd_type: 'D000501',
          gd_code: '1001'
        }),
        {
          headers: {
            'x-http-appid': '1',
            'x-http-device': '0',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: TOKEN,
            farmorg: FARM_ORG,
            orgcode: ORG_CODE
          }
        }
      )
      .then((res) => {
        dataReady++;
        let data = res.data;
        this.setState({
          aveNPDay: data[0].val, // 平均脱产天数
          npPer: data[1].val,
          totalQty: data[2].val // 总脱产母猪
        });
      })
      .catch((err) => {
        return err;
      });
  };
  doSearch = (date) => {
    dataReady = 0;
    Toast.loading('加载中', 0);
    var d = df(date || new Date(), 'yyyy-mm-dd');
    this.getData1(d);
    this.getData2(d);
    this.getTotal(d);
  };
  componentDidMount() {
    window._czc.push(['_trackEvent', '进入脱产母猪分析页面']);
    this.doSearch(new Date());
  }
  componentDidUpdate() {
    dataReady === 3 && Toast.hide();
  }
  componentWillUnmount() {
    this.setState(() => {
      return;
    });
  }

  render() {
    return (
      <React.Fragment>
        <DatePicker
          mode="date"
          onChange={(date) => {
            this.setState({ date });
            this.doSearch(date);
          }}
          value={this.state.date}
        >
          <List.Item arrow="horizontal">选择日期</List.Item>
        </DatePicker>

        <List renderHeader={() => ''}>
          <div style={{ display: this.state.dataNoData ? 'none' : 'block' }}>
            <Flex
              style={{
                padding: '15px 25px 0 25px',
                fontSize: '12px',
                color: '#999999'
              }}
            >
              <Flex.Item>
                平均脱产天数：
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#333'
                  }}
                >
                  {this.state.aveNPDay}
                </span>
              </Flex.Item>
              <Flex.Item>
                脱产母猪占比：
                <span
                  style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#333'
                  }}
                >
                  {this.state.npPer}
                </span>
              </Flex.Item>
            </Flex>
            <Flex
              style={{
                padding: '10px 25px',
                fontSize: '12px',
                color: '#999999'
              }}
            >
              脱产母猪数量：
              <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>{this.state.totalQty}</span>
            </Flex>
            <canvas height="360" id="myChart1" width={clientWidth} />
          </div>
          {this.state.dataNoData && <EmptyReport height={300} width={clientWidth} />}
        </List>

        {this.state.tables.length > 0 && (
          <List
            renderFooter={() => ''}
            renderHeader={
              <Flex>
                <Flex.Item>
                  <span>项目</span>
                </Flex.Item>
                <Flex.Item>
                  <Flex>
                    <Flex.Item style={{ textAlign: 'right' }}>数量</Flex.Item>
                    <Flex.Item style={{ textAlign: 'right' }}>平均脱产天数</Flex.Item>
                    <Flex.Item style={{ textAlign: 'right' }}>占比</Flex.Item>
                  </Flex>
                </Flex.Item>
              </Flex>
            }
          >
            {this.state.tables.map((item, index) => (
              <List.Item key={'table' + index}>
                <Flex alignContent="end" justify="center">
                  <Flex.Item
                    onClick={() => {
                      this.setState({
                        modalShow: true,
                        modalContent: <SwineDetails data={item} date={this.state.date} />
                      });
                    }}
                    style={{ fontSize: '13px', color: '#108EE9' }}
                  >
                    {item.descLoc}
                  </Flex.Item>
                  <Flex.Item>
                    <Flex style={{ textAlign: 'right' }}>
                      <Flex.Item>{item.val_1}</Flex.Item>
                      <Flex.Item>{item.val_2}</Flex.Item>
                      <Flex.Item>{item.val_3}</Flex.Item>
                    </Flex>
                  </Flex.Item>
                </Flex>
              </List.Item>
            ))}
          </List>
        )}
        {/*弹出层公用模态框、*/}
        <Modal
          animationType="slide-up"
          maskClosable={false}
          closable
          onClose={() => {
            this.setState({
              modalShow: false
            });
          }}
          popup
          visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
      </React.Fragment>
    );
  }
}

export default RealTime;
